/** @format */

import React from "react";

import { Link } from "react-router-dom";
import usePermissions from "../../components/permissions/permission";

const Warehouse_nav = () => {
  const { hasPermission } = usePermissions();
  const warehouseData = [
    {
      id: 1,
      header: "Warehouse Management",

      headerClasses: "text-black",
      linkTo: "/warehouse",
      permissionId: 1430,
    },
    {
      id: 2,
      header: "Warehouse Pending",

      headerClasses: "text-black",
      linkTo: "/warehouse-pending",
      permissionId: 1440,
    },
    {
      id: 3,
      header: "Warehouse Apporved",

      headerClasses: "text-black",
      linkTo: "/warehouse-complete",
      permissionId: 1450,
    },
    {
      id: 4,
      header: "Warehouse Rejected",

      headerClasses: "text-black",
      linkTo: "/warehouse-reject",
      permissionId: 1460,
    },
    {
      id: 5,
      header: "Warehouse Adjustment",

      headerClasses: "text-black",
      linkTo: "/warehouse-adjustments",
      permissionId: 1470,
    },
    {
      id: 6,
      header: "Add Pricing",

      headerClasses: "text-black",
      linkTo: "/warehouse-pending-for-pricing",
      permissionId: 1470,
    },
  ];

  return (
    <div className="bg-background overflow-y-auto h-screen">
      <p className="text-[25px] font-sans ml-6 mt-6 font-bold text-[#797C80] ">
        Warehouse
      </p>

      {/* Cards with "Click Here" buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 mt-[10%] mx-6 ">
        {warehouseData.map((card) =>
          hasPermission(card.permissionId) ? (
            <Link key={card.id} to={card.linkTo}>
              <div
                key={card.id}
                className="bg-white rounded-[32px] p-4 shadow-md flex flex-col justify-between"
              >
                <div>
                  {/* Conditional rendering based on header words */}
                  {card.header.split(" ").map((word, index) => (
                    <h2 key={index} className="text-[20px] font-semibold mb-1">
                      {word}
                    </h2>
                  ))}
                </div>
                <div className="flex justify-between items-center">
                  <button className="bg-primary w-[30%] mt-2 text-white font-bold py-2 px-4 rounded-[22px]">
                    Click Here
                  </button>

                  <div className="bg-primary w-[13px] h-[37px] rounded-xl"></div>
                </div>
              </div>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Warehouse_nav;
